// Tenant de la SESSION, tel qu'il est connu côté navigateur — ou `null`.
// ⛔ Aucun repli sur un tenant nommé : sans tenant résolu, l'appelant ne fait AUCUNE requête
// (un `X-Tenant-ID` inventé ferait lire — ou écrire — l'espace d'un autre).
export function tenantResolu() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.tenant_id || user?.tenant?.slug || localStorage.getItem("current_tenant_slug") || null;
  } catch {
    return null;
  }
}
